import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // No lanzamos excepción dura para no romper el build; se avisa en consola
  // y en pantalla (ver main.js) porque sin estas variables la app no puede
  // conectarse a Supabase.
  console.error(
    '[config] Faltan VITE_SUPABASE_URL y/o VITE_SUPABASE_ANON_KEY. ' +
    'Configúralas en .env.local (desarrollo) o en Netlify > Site settings > Environment variables (producción).'
  );
}

// El anon key de Supabase está diseñado para exponerse en el cliente: la
// seguridad real la da Row Level Security (RLS) en la base de datos, no el
// secreto de esta clave. El service_role key (sí sensible) nunca debe
// usarse aquí ni subirse al repositorio.
export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export const isSupabaseConfigured = Boolean(url && anonKey);
